import { useEffect, useState } from "react";
import Lenis from "lenis";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import Pricing from "@/components/site/Pricing";
import Testimonials from "@/components/site/Testimonials";
import ServiceArea from "@/components/site/ServiceArea";
import BookingWizard from "@/components/site/BookingWizard";
import Contact from "@/components/site/Contact";

export default function Landing() {
  const [ready, setReady] = useState(false);
  const [prefill, setPrefill] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;
    setReady(true);

    // Handle deferred scroll target (from other routes) or hash
    const pending = sessionStorage.getItem("bac_scroll");
    const hash = window.location.hash?.replace("#", "");
    const target = pending || hash;
    if (target) {
      sessionStorage.removeItem("bac_scroll");
      setTimeout(() => {
        const el = document.getElementById(target);
        if (el) lenis.scrollTo(el, { offset: -20 });
      }, 300);
    }

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  const scrollTo = (target) => {
    const id = target.replace("#", "");
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -20 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  const handleQuote = (data) => {
    setPrefill({ ...data, _ts: Date.now() });
    scrollTo("#booking");
  };

  return (
    <>
      <Navbar onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} ready={ready} />
        <Marquee />
        <Manifesto />
        <Services onNavigate={scrollTo} />
        <Gallery />
        <Pricing onQuote={handleQuote} />
        <Testimonials />
        <ServiceArea />
        <BookingWizard prefill={prefill} />
        <Contact onNavigate={scrollTo} />
      </main>
    </>
  );
}
